import { Box, Container, Typography } from "@mui/material";
import LoadingPage from "components/LoadingPage";
import { useOnScreen } from "hooks/useOnScreen";
import useScreenSize from "hooks/useScreenSize";
import { useGlobalSlickAccessibilityFix } from "hooks/useSlickAccessibilityFix";
import { lazy, Suspense, useCallback, useEffect } from "react";
import TopPresentation from "./components/TopPresentation";

const OurServices = lazy(() => import("./components/OurServices"));
const ListClients = lazy(() => import("components/ListClients"));

function Home() {
  useGlobalSlickAccessibilityFix();

  const { isMobile } = useScreenSize({ breakpoint: 1024 });
  const [servicesRef, isServicesVisible] = useOnScreen<HTMLDivElement>();
  const [clientsRef, isClientsVisible] = useOnScreen<HTMLDivElement>();

  const onContactClick = useCallback(() => {
    window.open("https://api.whatsapp.com/send?phone=5511964914546", "_blank");
  }, []);

  useEffect(() => {
    const SRC = "https://elfsightcdn.com/platform.js";

    // Se o script já foi injetado, apenas pede para a Elfsight re-escanear a página.
    if (document.querySelector(`script[src="${SRC}"]`)) {
      (window as any).eapps?.PlatformService?.initWidgetsFromBuffer?.();
      return;
    }

    const script = document.createElement("script");
    script.src = SRC;
    script.async = true;
    document.body.appendChild(script);
  }, []);

  return (
    <>
      <TopPresentation onContactClick={onContactClick} />
      {isMobile && <OurServices />}
      {isMobile && <ListClients />}

      <div ref={servicesRef} />
      {!isMobile && isServicesVisible && (
        <Suspense fallback={<LoadingPage />}>
          <OurServices />
        </Suspense>
      )}

      <div ref={clientsRef} />
      {!isMobile && isClientsVisible && (
        <Suspense fallback={<LoadingPage />}>
          <ListClients />
        </Suspense>
      )}

      {/* Elfsight Google Reviews | Sistemas Flex - Site */}
      <Container>
        <Box>
          <Typography
            variant="h4"
            component="h2"
            fontWeight="bold"
            textAlign="center"
            marginTop={6}
            sx={{
              "@media (max-width:480px)": {
                fontSize: "20px",
                mb: 1.5,
              },
            }}
          >
            O que dizem nossos clientes
          </Typography>
        </Box>
      </Container>
      <div
        className="elfsight-app-cdc8ec2f-514f-479c-93c0-72b751bfc629 mt-2 mb-9 sm:my-9 px-8"
        data-elfsight-app-lazy
      ></div>
    </>
  );
}

export default Home;
